import { AccessGate, RedirectBehavior, usePageBuilderAccessStrategies } from "../../../permissions/access";

export function PageBuilderAccessGate({ children }: { children: React.ReactElement }) {
  const strategies = usePageBuilderAccessStrategies();

  return (
    <AccessGate
      strategy={strategies}
      // Each behavior maps to the strategy at the same index.
      behavior={[RedirectBehavior, RedirectBehavior]}
      behaviorConfig={[
        { to: "/signin", replace: true },
        { to: "/flow-hub", replace: true },
      ]}
    >
      {children}
    </AccessGate>
  );
}
